module.exports = __webpack_public_path__ + "img/Skirt-Front-B6-Da-Ge-Ha-Ia-outside.f8cad7de.png";